import formatMoney from '../formatMoney';
import { getDisplayCents } from '../vatBasis';

const updateFormControls = ({
  variant,
  qty,
  atcButton,
  atcButtonPrice,
  quantitySelector
}) => {
  if (!atcButton || !atcButtonPrice || !quantitySelector || !variant) return;

  const quantityControls = quantitySelector.querySelectorAll('button, input');

  const price = variant.price;
  quantitySelector.dataset.qtySelectorVariantPrice = price;
  const unitDisplay = getDisplayCents(price);
  atcButtonPrice.textContent = formatMoney(unitDisplay * qty, window.theme.moneyFormat);

  if (variant && variant.available) {
    quantityControls.forEach(control => control.removeAttribute('disabled'));
    atcButton.disabled = false;
  } else {
    quantityControls.forEach(control => control.setAttribute('disabled', true));
    atcButton.disabled = true;
  }
};

export default updateFormControls;
